export const PersonalAddressEnum = Object.freeze({
    homePrivate: 'Home',
    office: 'Company',
    none: 'none'
})